import ErrorBlock from './ErrorBlock'

export default ErrorBlock